import { useEffect, useRef } from "react";
import { useLearningCatalogue } from "../context";
import { SORT_OPTIONS, SORT_ORDER_RATING_DESC_INT } from "../constants";

export const useToolbar = () => {
  const {
    state,
    setSearchText,
    toggleListView,
    handleShowAdvancedFilter,
    setSortOrder,
  } = useLearningCatalogue();

  const { searchText, listView, sortOrder, showAdvancedFilter, displayRating } =
    state;

  const displayRatingInitialized = useRef(false);
  const prevDisplayRating = useRef(displayRating);

  useEffect(() => {
    if (!displayRatingInitialized.current) {
      displayRatingInitialized.current = true;
      prevDisplayRating.current = displayRating;
      return;
    }
    prevDisplayRating.current = displayRating;
  }, [displayRating]);

  const sortTypeOnChange = (updatedSortType) => {
    setSortOrder(updatedSortType);
  };

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleSearchClear = async () => {
    await setSearchText("");
  };

  const handleSearchSubmit = async (searchValue) => {
    await setSearchText(searchValue);
  };

  const filteredSortOptions = displayRating
    ? SORT_OPTIONS
    : SORT_OPTIONS.filter(
        (option) => option.value !== SORT_ORDER_RATING_DESC_INT,
      );

  useEffect(() => {
    if (
      displayRatingInitialized.current &&
      prevDisplayRating.current === true &&
      !displayRating &&
      sortOrder === SORT_ORDER_RATING_DESC_INT
    ) {
      setSortOrder(0);
    }
  }, [displayRating, sortOrder, setSortOrder]);

  const sortOptionValue =
    filteredSortOptions.find((option) => option.value === sortOrder)?.value ||
    0;

  return {
    searchText,
    listView,
    sortOptionValue,
    showAdvancedFilter,
    sortTypeOnChange,
    handleSearchChange,
    handleSearchClear,
    handleSearchSubmit,
    toggleListView,
    handleShowAdvancedFilter,
    sortOptions: filteredSortOptions,
  };
};
